module.exports = __webpack_public_path__ + "img/unita_di_mis_invoiceweb.fee20037.png";